// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import AppNav from '../app-nav';
import AppBanner from '../shared/AppBanner.js';
import PageHeader from '../shared/PageHeader';
import { BannersStore, Banner } from '../../types/banner';
import { removeBanner, clearBanners } from '../../actions/banners';

const mapStateToProps = (appState) => ({
  user: appState.user,
  banners: appState.banners
});

const mapDispatchToProps = (dispatch) => ({
  removeBanner: (bannerType: string) => dispatch(removeBanner(bannerType)),
  clearBanners: () => dispatch(clearBanners())
});

type LayoutProps = {
  children: any,
  className: string,
  navClassName?: string,
  viewType: string,
  user: {},
  banners: BannersStore,
  frameless?: boolean,
  headerChildren?: any,
  fullWidth: boolean,
  pageMessage?: string,
  navClassName?: string,
  pageClassName?: string,
  headerClass?: string,
  pageTitle?: string,
  pageSubtitle?: string,
  clearBanners: () => void,
  shareBanner?: any,
  partnerLogo?: any
}

class AppView extends Component {
  props: LayoutProps;
  componentWillMount() {
    this.props.clearBanners();
  }

  render() {
    const { children, fullWidth, navClassName, pageClassName, className, partnerLogo,
      pageTitle, pageSubtitle, headerClass, pageMessage, banners, frameless, shareBanner } = this.props;
    return (
      <div className={`app-container is-authenticated is-app ${className}`} >
        <div className='banner-container'>
          {banners.data && banners.data.length > 0 && banners.data.map((banner: Banner, i) => (
            <AppBanner
              {...banner}
              key={i}
            />
            ))}
          {frameless && shareBanner}
        </div>

        <div>
          {!frameless &&
            <AppNav className={navClassName} partnerLogo={partnerLogo} />
          }
          {pageTitle ? (
            <PageHeader
              title={pageTitle}
              subtitle={pageSubtitle}
              className={headerClass}
              pageMessage={pageMessage}
            >
              {this.props.headerChildren}
            </PageHeader>
          ) : ''}

          <div
            className={`${pageTitle ? '' : `page-container ${pageClassName}`}
              ${fullWidth ? `fullwidth-container ${pageClassName}` : `container ${pageClassName}`}`
            }
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AppView);



// WEBPACK FOOTER //
// ./src/components/layouts/AppView.js